export class EpbtFaGridBaseModel {
    constructor(bistrackSettings, webTrackUser, loadDataOnload: boolean = false) {
        this.bistrackSettings = bistrackSettings;
        this.webTrackUser = webTrackUser;
        this.loadDataOnload = loadDataOnload;
    }

    bistrackSettings: any;
    webTrackUser: any;
    loadDataOnload: boolean;
}
